import { ApiProvider } from '@api/ApiProvider'
import type { Endpoints } from '@api/endpoints'
import { StaffSessionProvider } from '@features/panel/StaffSession'
import { I18nProvider } from '@i18n/I18nProvider'
import type { Locale } from '@i18n/locale'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { type ReactNode, useState } from 'react'

// Caché de datos pensada para el Camino: el contenido cambia poco (5 min frescos) y la
// cobertura es mala (2 reintentos, sin recargar al volver a la pestaña).
export const createQueryClient = (): QueryClient =>
	new QueryClient({
		defaultOptions: {
			queries: { staleTime: 5 * 60_000, retry: 2, refetchOnWindowFocus: false },
			mutations: { retry: 0 },
		},
	})

export const AppProviders = ({
	children,
	endpoints,
	queryClient,
	initialLocale,
}: {
	children: ReactNode
	endpoints?: Endpoints
	queryClient?: QueryClient
	initialLocale?: Locale
}) => {
	const [client] = useState(() => queryClient ?? createQueryClient())
	return (
		<QueryClientProvider client={client}>
			<ApiProvider endpoints={endpoints}>
				<I18nProvider initialLocale={initialLocale}>
					{/* La sesión del personal es de toda la app: el mapa también la usa (moderar lugares mágicos). */}
					<StaffSessionProvider>{children}</StaffSessionProvider>
				</I18nProvider>
			</ApiProvider>
		</QueryClientProvider>
	)
}
